// GA4 이벤트 발신 — 결제 퍼널 계측.
//
// 서버는 예약 생성(BOOKING)과 결제 완료(PAYMENT_COMPLETED)만 기록한다. 그 사이에서
// 무슨 일이 일어나는지는 «클라이언트에서만» 알 수 있고(PayPal 팝업), 지금 prod 는
// 예약 시도 대비 완료가 10% 라 그 구간이 곧 병목이다. 여기 이벤트가 그 구간을 채운다.
//
// ⚠️ 예약 uuid 는 절대 보내지 않는다 — 그 값이 곧 조회·취소 권한(bearer capability)
// 이라 서드파티 분석 도구에 흘리면 크리덴셜 유출이다. 서비스 uuid·금액만 보낸다.

import { capture } from "./posthog.ts";

export const AnalyticsEvent = {
  /** 상품 상세에 들어왔다 — 대시보드 세그먼트 «핵심 행동»·퍼널 «상품 조회» 단계 */
  serviceViewed: 'service_viewed',
  /**
   * 상품 상세에서 예약 버튼을 눌렀다.
   *
   * 서버 VIEW 와 checkout_started 사이가 비어 있어, 90일 조회 1,301건 → 예약 생성
   * 9건의 손실이 «상세에서 안 누른 것» 인지 «누르고 예약 폼에서 죽은 것» 인지
   * 구분할 수 없었다. 이 이벤트 하나가 그 둘을 가른다.
   */
  bookingCtaClicked: 'booking_cta_clicked',
  /** 예약이 생성돼 결제 화면(모달)이 열렸다 */
  checkoutStarted: 'checkout_started',
  /** 결제 수단 버튼을 눌러 주문 생성이 시작됐다 */
  paymentInitiated: 'payment_initiated',
  /** 사용자가 결제창을 닫았다 */
  paymentCancelled: 'payment_cancelled',
  /** 결제가 오류로 끝났다(주문 생성 실패·캡처 실패 포함) */
  paymentFailed: 'payment_failed',
  /** 결제가 성사됐다 */
  paymentCompleted: 'payment_completed',
} as const;

type Props = Record<string, string | number | boolean | undefined>;

export function logEvent(event: string, props: Props = {}): void {
  try {
    const clean: Props = {};
    for (const [k, v] of Object.entries(props)) if (v !== undefined) clean[k] = v;
    (window as any).gtag?.('event', event, clean);
    capture(event, clean);
  } catch {
    /* 계측이 결제를 막으면 안 된다 */
  }
}

// bearer 가 되는 경로 세그먼트: 예약 상세·배달 주문 상세. 쿼리·해시(인증 콜백 포함)는 통째로 버린다.
// TODO: feature/user-analytics-posthog 의 src/utils/posthog.ts sanitizeUrl 과 같은 규칙 — 머지 후 하나로 합칠 것.
const MASKED = /(\/(?:reservation|booking|delivery\/orders)\/)[^/?#]+/;

export function sanitizeUrl(url: string): string {
  return url.replace(/[?#].*$/, '').replace(MASKED, '$1:uuid');
}
